import { layout } from 'thewest/App.routing'

export const regionalSegment = layout.component({
    type: 'uniform',
    props: {
        verticalSpacing: 'xl',
        section: 'default',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            ['noImageWithBackground', 'titleOnly'],
            ['teaserWithBackground'],
            ['titleOnly', 'noImageWithBackground'],
        ],
        sectionHeader: {
            heading: 'Regional',
            headingUrl: '/news/regional',
            section: 'generic',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'regional',
            offset: 0,
            pageSize: 7,
        },
    },
})
